<ng-template #modalContent let-modal>
  <dcp-country-switch-content [countries]="countries" [modal]="modal" [requestedCountry]="requestedCountry">
  </dcp-country-switch-content>
</ng-template>

